var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"p-25"},[_c('div',{staticClass:"md:flex justify-between items-center md:space-y-0 space-y-20"},[_c('CurrentBalanceHeader'),_c('HMButton',{attrs:{"to":{ name: 'rewards-redeem' }}},[_vm._v(" "+_vm._s(_vm.canAffordRedemption ? _vm.$t('rewards.landing.redeem_now') : _vm.$t('rewards.landing.view_rewards'))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }